interface Props {
    title: string;
  }

export default function MenuHeader(props: Props) {
    return <><p className="px-5 mt-5 text-gray-800 font-bold">{props.title}</p></>
}